import { apiClient } from "../Config/ApiClient";

export const retrieveIndex = (token) => apiClient.get(`/ppap-index`, { headers: {'Authorization': token }});

export const retrieveIndexHistory = (start_date, end_date, token) => apiClient.get('/index/history-data', { params: {start_date: start_date, end_date: end_date}, headers: {'Authorization': token} });

export const retrieveUpdateIndex = (token) => apiClient.get('/index/update-index', { headers: {'Authorization': token} });